module.exports = __webpack_public_path__ + "img/perekladach.a86284a5.png";